module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginLeft": 90,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -145,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.29963898916968,
						"dataLabels": {
							"enabled": true,
							"format": "2134"
						}
					},
					{
						"y": 86.32671480144406,
						"dataLabels": {
							"enabled": true,
							"format": "1913"
						}
					},
					{
						"y": 82.2653429602888,
						"dataLabels": {
							"enabled": true,
							"format": "1823"
						}
					},
					{
						"y": 76.12815884476535,
						"dataLabels": {
							"enabled": true,
							"format": "1687"
						}
					},
					{
						"y": 64.57581227436823,
						"dataLabels": {
							"enabled": true,
							"format": "1431"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.81931464174455,
						"dataLabels": {
							"enabled": true,
							"format": "628"
						}
					},
					{
						"y": 80.06230529595015,
						"dataLabels": {
							"enabled": true,
							"format": "514"
						}
					},
					{
						"y": 75.38940809968847,
						"dataLabels": {
							"enabled": true,
							"format": "484"
						}
					},
					{
						"y": 71.33956386292834,
						"dataLabels": {
							"enabled": true,
							"format": "458"
						}
					},
					{
						"y": 53.11526479750779,
						"dataLabels": {
							"enabled": true,
							"format": "341"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.56913183279742,
						"dataLabels": {
							"enabled": true,
							"format": "291"
						}
					},
					{
						"y": 79.7427652733119,
						"dataLabels": {
							"enabled": true,
							"format": "248"
						}
					},
					{
						"y": 72.9903536977492,
						"dataLabels": {
							"enabled": true,
							"format": "227"
						}
					},
					{
						"y": 67.20257234726688,
						"dataLabels": {
							"enabled": true,
							"format": "209"
						}
					},
					{
						"y": 44.05144694533762,
						"dataLabels": {
							"enabled": true,
							"format": "137"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.99447965651196,
						"dataLabels": {
							"enabled": true,
							"format": "4744"
						}
					},
					{
						"y": 85.09507258229401,
						"dataLabels": {
							"enabled": true,
							"format": "4162"
						}
					},
					{
						"y": 81.39439787364547,
						"dataLabels": {
							"enabled": true,
							"format": "3981"
						}
					},
					{
						"y": 75.93539153547331,
						"dataLabels": {
							"enabled": true,
							"format": "3714"
						}
					},
					{
						"y": 66.38724187282764,
						"dataLabels": {
							"enabled": true,
							"format": "3247"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.45685740236148,
						"dataLabels": {
							"enabled": true,
							"format": "1073"
						}
					},
					{
						"y": 86.92098092643052,
						"dataLabels": {
							"enabled": true,
							"format": "957"
						}
					},
					{
						"y": 83.28792007266121,
						"dataLabels": {
							"enabled": true,
							"format": "917"
						}
					},
					{
						"y": 76.74841053587647,
						"dataLabels": {
							"enabled": true,
							"format": "845"
						}
					},
					{
						"y": 58.58310626702997,
						"dataLabels": {
							"enabled": true,
							"format": "645"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.700361010830322,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.356138706654171,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.704652378463148,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.460230389467915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.174866627148786,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.180685358255452,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.15286624203821,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.836575875486383,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.371900826446286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.54585152838428,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.430868167202575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.7766323024055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.467741935483875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.929515418502198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.44976076555024,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.005520343488044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.268128161888702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.3488707352234535,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.706857573474001,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.57404415724287,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5431425976385147,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.81081081081081,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.1797283176593485,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.851690294438384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.668639053254438,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2216"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=642"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=311"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4891"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1101"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2216,
				2134,
				1913,
				1823,
				1687,
				1431
			],
			"Interior Health": [
				642,
				628,
				514,
				484,
				458,
				341
			],
			"Northern Health": [
				311,
				291,
				248,
				227,
				209,
				137
			],
			"Vancouver Coastal Health": [
				4891,
				4744,
				4162,
				3981,
				3714,
				3247
			],
			"Vancouver Island Health": [
				1101,
				1073,
				957,
				917,
				845,
				645
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 170
// module chunks = 0